import React from 'react';

const ProductBagIconButton = ({quantity, icon, text, active, href = '#'}) => {
    
    const className = 'product-bag__icon ' + 'product-bag__icon--' + icon + (active ? ' product-bag__icon--' + icon + '-active' : ' product-bag__icon--' + icon + '-active');
    
    return (
        <a
            id="product_bag_link"
            className="product-bag__link"
            rel="nofollow"
            href={href}
        >
            <i className={className}>
                <span className="product-bag__quantity">{quantity}</span>
            </i>
            
            <span className="product-bag__text">{text}</span>
        </a>
    );
}

export default ProductBagIconButton;
